import { render, staticRenderFns } from "./detailLog.vue?vue&type=template&id=67c143fc"
import script from "./detailLog.vue?vue&type=script&lang=js"
export * from "./detailLog.vue?vue&type=script&lang=js"
import style0 from "./detailLog.vue?vue&type=style&index=0&id=67c143fc&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67c143fc')) {
      api.createRecord('67c143fc', component.options)
    } else {
      api.reload('67c143fc', component.options)
    }
    module.hot.accept("./detailLog.vue?vue&type=template&id=67c143fc", function () {
      api.rerender('67c143fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/basicData/cope/quotationManagement/cmp/detailLog.vue"
export default component.exports